import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'spotlight-ui/environments/environment';

export const CUSTOMER_SOURCE_INJECTION_TOKEN: InjectionToken<CustomerSource> = new InjectionToken<CustomerSource>('CustomerSource');

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  constructor(@Inject(CUSTOMER_SOURCE_INJECTION_TOKEN) private readonly customerSource: CustomerSource) { }
  getCustomerProfiles(locationNumber: string, ids: string[]): Observable<Customer[]> {
    return this.customerSource.getCustomers(locationNumber, ids);
  }
}

interface CustomerSource {
  getCustomers: (locationNumber: string, ids: string[]) => Observable<Customer[]>;
}

export interface Customer {
  cfaID: string;
  firstName: string;
  lastName: string;
  showCustomerProfile: boolean;
}

@Injectable({ providedIn: 'root' })
export class LegacySpotlightCustomerSource implements CustomerSource {
  constructor(private readonly httpClient: HttpClient) { }
  public getCustomers(locationNumber: string, ids: string[]): Observable<Customer[]> {
    let url = `/api/location/${locationNumber}/customersById`;
    const customerList: Subject<Customer[]> = new Subject<Customer[]>();
    this.httpClient.post(environment.spotlightApiUrl + url, ids).subscribe({
      next: (response: any) => {
        customerList.next(this.apiResponseToCustomerList(response.responseObject.customerProfiles));
        customerList.complete();
      },
      error: (error) => customerList.error(error)
    });
    return customerList.asObservable();
  }

  private apiResponseToCustomerList(response: any[]): Customer[] {
    return response.map((profile: any) => {
      return {
        firstName: profile.firstName,
        lastName: profile.lastName,
        cfaID: profile.id,
        showCustomerProfile: profile.showCustomerProfile,
      }
    })
  }
}
